<template>
  <div class="renderPage ac-container" :class="{ 'theme--dark': $vuetify.theme.dark }">
    <!-- TOOLBAR CABECERA -->
    <v-toolbar flat height="56" :color="$vuetify.theme.dark ? '#1e293b' : '#f1f5f9'" class="ac-toolbar px-2">
      <v-icon class="mr-2" :color="$vuetify.theme.dark ? 'cyan lighten-2' : 'blue-grey darken-3'">mdi-clipboard-check-multiple-outline</v-icon>
      <v-toolbar-title class="font-weight-black text-uppercase ac-toolbar-title" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-4'">
        Aceptación de Compras
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon :color="$vuetify.theme.dark ? 'blue-grey lighten-2' : 'grey darken-1'" @click="getData()">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- TABLA -->
    <v-card flat class="ac-table-card mx-0" :color="$vuetify.theme.dark ? '#0f172a' : 'white'">
      <v-toolbar flat height="auto" :color="$vuetify.theme.dark ? '#0f172a' : 'white'" class="px-3 pt-2 pb-3">
        <v-row dense align="center">
          <v-col cols="12" sm="5">
            <v-select
              v-model="codigoActividadAll"
              :items="actividades"
              :loading="loadingActividades"
              no-data-text="No hay actividades para esta compañía"
              item-text="descripcion"
              item-value="codigo"
              :label="'Actividad Económica (Masivo) (' + (actividades ? actividades.length : 0) + ')'"
              outlined dense hide-details
              prepend-inner-icon="mdi-briefcase-outline"
              class="ac-search"
            >
              <template v-slot:selection="{ item }">{{ item ? (item.descripcion || item.Descripcion || item.Nombre) : '' }}</template>
              <template v-slot:item="{ item }">{{ item ? ((item.codigo || item.Codigo) + ' - ' + (item.descripcion || item.Descripcion || item.Nombre)) : '' }}</template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="3">
            <v-select
              v-model="estadoDevAll"
              :items="estadosCompras"
              item-text="descripcion"
              item-value="codigo"
              label="Estado Masivo"
              outlined dense hide-details
              class="ac-search"
            >
              <template v-slot:selection="{ item }">{{ item.descripcion || item.Descripcion }}</template>
              <template v-slot:item="{ item }">{{ (item.codigo || item.Codigo) }} - {{ (item.descripcion || item.Descripcion) }}</template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="2" class="d-flex align-center">
            <v-btn
              color="primary"
              depressed block
              @click="enviarSeleccionados"
              :disabled="selected.length === 0 || visibleLoteProgress"
              :loading="visibleLoteProgress"
              class="font-weight-bold ac-btn"
            >
              <v-icon left>mdi-send</v-icon>
              Enviar
            </v-btn>
          </v-col>
          <v-col cols="12" sm="2">
             <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar..."
                single-line hide-details outlined dense
                class="ac-search"
              ></v-text-field>
          </v-col>
        </v-row>
      </v-toolbar>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="itemsFilter"
        item-key="codigoFact"
        show-select
        :search="search"
        class="ac-table"
        @click:row="editItem"
        style="cursor:pointer"
      >
        <template v-slot:item.codigoDev="{ item }">
          <v-chip
            small
            :color="getEstadoColor(item.codigoDev)"
            class="font-weight-black border-none"
            text-color="white"
          >
            {{ item.codigoDev }}
          </v-chip>
        </template>

        <template v-slot:item.estadoInventario="{ item }">
          <v-chip
            small
            label
            :color="item.estadoInventario === 'CARGADO' ? 'success' : 'grey lighten-1'"
            class="font-weight-bold"
            :outlined="item.estadoInventario !== 'CARGADO'"
            style="cursor: pointer"
            @click.stop="openInventoryMapper(item)"
          >
            <v-icon x-small left>{{ item.estadoInventario === 'CARGADO' ? 'mdi-check-circle' : 'mdi-clock-outline' }}</v-icon>
            {{ item.estadoInventario || 'PENDIENTE' }}
          </v-chip>
        </template>

        <template v-slot:item.tipoDoc="{ item }">
          <v-chip
            small
            outlined
            color="primary"
            class="font-weight-medium"
          >
            {{ getTipoDocumento(item.clavehacienda) }}
          </v-chip>
        </template>

        <template v-slot:item.totalComprobanteStr="{ item }">
          <span class="font-weight-bold primary--text">{{ item.totalComprobanteStr }}</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <div class="d-flex align-center">
            <v-btn icon small color="primary" @click.stop="editItem(item)" class="mr-1 shadow-sm" title="Ver Detalle">
              <v-icon small>mdi-eye-outline</v-icon>
            </v-btn>
            <v-btn 
              icon small 
              :color="item.estadoInventario === 'CARGADO' ? 'success' : 'orange'" 
              @click.stop="openInventoryMapper(item)"
              :disabled="item.estadoInventario === 'CARGADO'"
              class="shadow-sm"
              v-if="getTipoDocumento(item.clavehacienda) !== 'Nota Crédito'"
              title="Cargar Inventario"
            >
              <v-icon small>{{ item.estadoInventario === 'CARGADO' ? 'mdi-package-variant-closed' : 'mdi-package-variant-plus' }}</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:item.clasificacion="{ item }">
          <v-chip
            x-small
            label
            class="font-weight-black"
            :color="item.clasificacion === 'M' ? 'indigo darken-2' : 'deep-orange darken-3'"
            dark
          >
            {{ item.clasificacion === 'M' ? 'MERCADERÍA' : 'GASTO' }}
          </v-chip>
        </template>

        <template v-slot:no-data>
          <div class="pa-8 text-center">
            <v-icon size="48" :color="$vuetify.theme.dark ? 'blue-grey darken-1' : 'grey lighten-1'" class="mb-3">mdi-cart-off</v-icon>
            <p :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">No hay comprobantes pendientes de aceptar</p>
            <v-btn color="primary" depressed small @click="getData()">Actualizar</v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- SUPER DRAWER - DETALLE Y ACEPTACIÓN -->
    <v-navigation-drawer
      v-model="drawerForm"
      fixed right temporary
      :disable-route-watcher="docViewerDialog"
      :stateless="docViewerDialog"
      :width="$vuetify.breakpoint.mdAndUp ? 'calc(100% - 290px)' : '100%'"
      class="ac-drawer"
    >
      <div class="d-flex flex-column fill-height">
        <!-- HEADER DEL DRAWER -->
        <div class="ac-drawer-header d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'ac-drawer-header--dark' : ''">
          <v-icon color="white" class="mr-3">mdi-clipboard-check-multiple-outline</v-icon>
          <div>
            <div class="white--text font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.95rem;">
              Detalles de Aceptación
            </div>
            <div class="caption white--text" style="opacity:0.7">
              {{ editedItem.codigoFact ? 'Comprobante #' + editedItem.codigoFact : 'Procesando selección...' }}
              <v-chip v-if="editedItem.estadoHacienda" x-small dark outlined class="ml-2 font-weight-black" style="height:18px">
                {{ editedItem.estadoHacienda }}
              </v-chip>
            </div>
          </div>
          <v-spacer />
          <v-btn icon dark small @click="cerrar()"><v-icon>mdi-close</v-icon></v-btn>
        </div>

        <!-- CONTENIDO DEL DRAWER -->
        <div class="flex-grow-1 overflow-y-auto px-2 py-2 bg-light">
          <v-form v-model="valid" ref="form">
            <v-expansion-panels v-model="activePanels" multiple class="modern-panels">
              
              <!-- INFO EMISOR / RECEPTOR -->
              <v-expansion-panel class="rounded-xl mb-2 elevation-0 border-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <v-icon color="primary" left class="mr-2">mdi-account-switch-outline</v-icon>
                  Información del Documento
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="editedItem.clienteNombre" label="Emisor" outlined dense hide-details readonly :background-color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="editedItem.emisorNombre" label="Receptor" outlined dense hide-details readonly :background-color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="editedItem.fechaHaciendaString" label="Fecha Emisión" outlined dense hide-details readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="editedItem.moneda" label="Moneda" outlined dense hide-details readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field :value="getCondicionVentaText(editedItem.condicionVenta)" label="Condición Venta" outlined dense hide-details readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="editedItem.clavehacienda" label="Clave Hacienda" outlined dense hide-details readonly></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- LINEAS DE DETALLE -->
              <v-expansion-panel class="rounded-xl mb-2 elevation-0 border-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <v-icon color="primary" left class="mr-2">mdi-format-list-bulleted</v-icon>
                  Líneas de Detalle
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    :headers="headersDetalle"
                    :items="lineasDetalle"
                    hide-default-footer
                    class="modern-table border-light rounded-lg overflow-hidden"
                    :items-per-page="-1"
                  ></v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- ACEPTACIÓN -->
              <v-expansion-panel class="rounded-xl mb-2 elevation-0 border-light border-primary-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <v-icon color="primary" left class="mr-2">mdi-shield-check-outline</v-icon>
                  Respuesta y Aceptación
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :value="editedItem.estadoHaciendaEmisor || 'PENDIENTE'"
                        label="Estado FE Emisor"
                        outlined dense hide-details readonly
                        prepend-inner-icon="mdi-file-check-outline"
                        :background-color="editedItem.estadoHaciendaEmisor === 'ACEPTADO' ? ($vuetify.theme.dark ? 'green darken-4' : 'green lighten-5') : editedItem.estadoHaciendaEmisor === 'RECHAZADO' ? ($vuetify.theme.dark ? 'red darken-4' : 'red lighten-5') : ($vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4')"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="editedItem.estadoDev"
                        :items="estadosCompras"
                        item-text="descripcion"
                        item-value="codigo"
                        label="Mi Respuesta Comercial"
                        outlined dense hide-details
                        prepend-inner-icon="mdi-check-decagram-outline"
                        :menu-props="{ zIndex: 300 }"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :value="editedItem.estadoHacienda || 'PENDIENTE'"
                        label="Estado Hacienda (Mi Aceptación)"
                        outlined dense hide-details readonly
                        prepend-inner-icon="mdi-cloud-check-outline"
                        :background-color="editedItem.estadoHacienda === 'ACEPTADO' ? ($vuetify.theme.dark ? 'green darken-4' : 'green lighten-5') : editedItem.estadoHacienda === 'RECHAZADO' ? ($vuetify.theme.dark ? 'red darken-4' : 'red lighten-5') : editedItem.estadoHacienda === 'PROCESANDO' ? ($vuetify.theme.dark ? 'blue darken-4' : 'blue lighten-5') : ($vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4')"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="mt-2 text-center">
                      <v-select
                        v-model="editedItem.clasificacion"
                        :items="[
                          { text: '📦 Mercadería', value: 'M' },
                          { text: '🛡️ Gasto / Servicio', value: 'S' }
                        ]"
                        label="Clasificación para Auditoría"
                        outlined dense hide-details
                        prepend-inner-icon="mdi-layers-triple-outline"
                        :menu-props="{ zIndex: 300 }"
                        @change="updateManualClassification"
                      ></v-select>
                      <span class="caption grey--text">Determina cómo se verá en el Dashboard Contable</span>
                    </v-col>
                    <v-col cols="12" md="6" class="mt-2">
                       <v-select
                        v-model="editedItem.codigoActividad"
                        :items="actividades"
                        :loading="loadingActividades"
                        no-data-text="No hay actividades para esta compañía"
                        item-text="descripcion"
                        item-value="codigo"
                        :label="'Actividad Económica (' + actividades.length + ')'"
                        outlined dense hide-details
                        prepend-inner-icon="mdi-briefcase-outline"
                        :menu-props="{ zIndex: 300 }"
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea v-model="editedItem.observacion" label="Detalle / Observación" outlined rows="2" hide-details class="mt-2"></v-textarea>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- RESUMEN DE TOTALES -->
              <v-expansion-panel class="rounded-xl mb-2 elevation-0 border-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <v-icon color="primary" left class="mr-2">mdi-calculator-variant-outline</v-icon>
                  Resumen Económico
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <!-- BARRA DE TOTALES PRINCIPALES -->
                  <v-row dense>
                    <v-col cols="12" md="3">
                      <v-card flat class="rounded-lg pa-2 bg-light border-light text-center">
                        <div class="caption grey--text mb-0">Subtotal</div>
                        <div class="text-body-2 font-weight-bold">{{ editedItem.subtotalStr || '0.00' }}</div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card flat class="rounded-lg pa-2 bg-light border-light text-center">
                        <div class="caption grey--text mb-0">Descuentos</div>
                        <div class="text-body-2 font-weight-bold red--text">{{ editedItem.totalDescuentosStr || '0.00' }}</div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card flat class="rounded-lg pa-2 bg-light border-light text-center">
                        <div class="caption grey--text mb-0">Impuestos</div>
                        <div class="text-body-2 font-weight-bold primary--text">{{ editedItem.totalImpuestoStr || '0.00' }}</div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card flat class="rounded-lg pa-2 primary border-light text-center white--text shadow-primary">
                        <div class="caption opacity-80 mb-0">TOTAL</div>
                        <div class="text-body-1 font-weight-black">{{ editedItem.totalComprobanteStr || '0.00' }}</div>
                      </v-card>
                    </v-col>
                  </v-row>

                  <!-- DESGLOSE DETALLADO DE IMPUESTOS -->
                  <v-row class="mt-4 border-top-light pt-4" dense>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="editedItem.totalIva1Str" label="IVA 1%" readonly outlined dense hide-details class="right-input"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="editedItem.totalIva2Str" label="IVA 2%" readonly outlined dense hide-details class="right-input"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="editedItem.totalIva4Str" label="IVA 4%" readonly outlined dense hide-details class="right-input"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="editedItem.totalIva13Str" label="IVA 13%" readonly outlined dense hide-details class="right-input"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                       <v-text-field v-model="editedItem.totalIVADevueltoStr" label="IVA Devuelto" readonly outlined dense hide-details class="right-input"></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- VISOR DE RESPUESTAS HACIENDA -->
              <v-expansion-panel v-if="editedItem.estadoHacienda" class="rounded-xl mb-2 elevation-0 border-light bg-light">
                <v-expansion-panel-header class="font-weight-bold secondary--text">
                  <v-icon color="secondary" left class="mr-2">mdi-cloud-sync-outline</v-icon>
                  Respuesta de Hacienda
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-textarea v-model="editedItem.mensajeHacienda" label="Mensaje del Servidor" readonly outlined rows="3" hide-details :background-color="$vuetify.theme.dark ? 'grey darken-3' : 'white'"></v-textarea>
                  <v-row class="mt-2" justify="center">
                    <v-btn text color="primary" @click="getXMLRecibido" :disabled="!verXMLRespuesta" class="rounded-pill"><v-icon left>mdi-file-import</v-icon> XML Recibido</v-btn>
                    <v-btn text color="primary" @click="getXMLFirmado" :disabled="!verXMLFirmado" class="rounded-pill"><v-icon left>mdi-file-export</v-icon> XML Enviado</v-btn>
                    <v-btn text color="primary" @click="getXMLRespuesta" :disabled="!verXMLRespuesta" class="rounded-pill"><v-icon left>mdi-message-reply-text</v-icon> Historial</v-btn>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-form>
        </div>

        <!-- FOOTER ACCIONES -->
        <div class="ac-drawer-footer d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'ac-drawer-footer--dark' : ''">
           <v-btn text class="font-weight-bold ac-btn" @click="cerrar()">Cancelar</v-btn>
           <v-btn
             v-if="getTipoDocumento(editedItem.clavehacienda) !== 'Nota Crédito' && editedItem.estadoInventario !== 'CARGADO'"
             color="teal darken-1"
             depressed dark
             class="ml-2 font-weight-bold ac-btn"
             @click="openInventoryMapper(editedItem)"
           >
             <v-icon left small>mdi-package-variant-plus</v-icon>
             Inventario
           </v-btn>
           <v-spacer />
           <v-btn
            color="primary"
            depressed
            class="px-8 font-weight-bold ac-btn"
            :loading="visibleProgress"
            @click="save"
            :disabled="!guardarValid"
          >
            <v-icon left small>mdi-check-all</v-icon>
            ACEPTAR DOCUMENTO
          </v-btn>
        </div>
      </div>
    </v-navigation-drawer>

    <!-- MAPEO DE INVENTARIO -->
    <InventoryMapper
      :show="showInventoryMapper"
      :lines="inventoryLines"
      :cia="strCia"
      :proveedorXml="currentProveedorXml"
      :localProveedor="currentLocalProveedor"
      @close="showInventoryMapper = false"
      @confirm="processInventoryConfirm"
      @supplier-registered="onSupplierRegistered"
    />

    <!-- VISOR DE DOCUMENTOS -->
    <v-dialog v-model="docViewerDialog" max-width="1100" eager>
      <v-card style="height: 88vh;" class="d-flex flex-column overflow-hidden rounded-xl">
        <div class="doc-viewer-toolbar d-flex align-center px-3 py-2 white--text flex-shrink-0">
          <v-icon color="white" size="18" class="mr-2">mdi-file-document-outline</v-icon>
          <span class="font-weight-bold text-subtitle-2">{{ docViewerTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn icon x-small dark class="mr-1" @click="abrirEnNuevaPestana" title="Abrir en nueva pestaña">
            <v-icon small>mdi-open-in-new</v-icon>
          </v-btn>
          <v-btn icon x-small dark @click="docViewerDialog = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
        <iframe v-if="docViewerDialog" :src="docViewerUrl" class="flex-grow-1" style="border: none; width: 100%;"></iframe>
      </v-card>
    </v-dialog>

    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";
import InventoryMapper from "./shared/InventoryMapper.vue";

export default {
  components: {
    Snackbar,
    InventoryMapper,
  },
  data() {
    return {
      showInventoryMapper: false,
      inventoryLines: [],
      inventoryProveedor: "",
      currentProveedorXml: null,
      currentLocalProveedor: null,
      processingInventory: false,
      btnAgregarDocumento: false,
      btnAgregarArti: false,
      iconVisible: false,
      iconVisibleCedula: false,
      visibleBtnConsultar: true,
      visibleProgress: false,
      visibleLoteProgress: false,
      dialog: false,
      valid: false,
      incluirValid: true,
      consultarEstadoValid: false,
      cancelarValid: false,
      guardarValid: false,
      search: "",
      snackText: "",
      snackValue: false,
      drawerForm: false,
      activePanels: [0, 1, 2],
      dialogDelete: false,
      verXMLFirmado: false,
      verXMLRespuesta: false,
      docViewerDialog: false,
      docViewerUrl: '',
      docViewerTitle: '',
      panel: [],
      panelResumen: [],
      codigoActividadAll: "",
      estadoDevAll: 0,
      selected: [],
      headers: [
        { text: "Código", align: "start", value: "codigoFact" },
        { text: "Proveedor", align: "start", value: "clienteNombre" },
        { text: "Fecha Hacienda", align: "start", value: "fechaHaciendaString" },
        { text: "Clave Emisor", align: "start", value: "clavehacienda" },
        { text: "Tipo Doc", align: "start", value: "tipoDoc" },
        { text: "Estado", align: "start", value: "codigoDev" },
        { text: "Total", align: "start", value: "totalComprobanteStr" },
        { text: "Stock", align: "center", value: "estadoInventario", sortable: false, width: 80 },
        { text: "Clasificación", align: "center", value: "clasificacion", sortable: false, width: 130 },
        { text: "Ver / Cargar", align: "start", value: "actions", width: 100, sortable: false },
      ],
      headersDetalle: [
        { text: "Cant", align: "start", value: "cantidad" },
        { text: "Cabys", align: "start", value: "cabys" },
        { text: "Descripción", align: "start", value: "descripcion" },
        { text: "Unidad", align: "start", value: "unidad" },
        { text: "Precio", align: "start", value: "montoStr" },
        { text: "Total", align: "start", value: "totalLineaStr" },
      ],
      estadosCompras: [
        { codigo: 1, descripcion: "ACEPTADO" },
        { codigo: 2, descripcion: "ACEPTADO PARCIAL" },
        { codigo: 3, descripcion: "RECHAZADO" },
      ],
      classificationOptions: [
        { text: "MERCADERIA", value: "M" },
        { text: "SERVICIOS / GASTOS", value: "S" },
      ],
      items: [],
      tiposIdentificacion: [],
      actividades: [],
      condicionesVenta: [],
      mediosPago: [],
      sucursales: [],
      terminales: [],
      monedas: [],
      cliente: [],
      articulo: [],
      totales: [],
      lineasDetalle: [],
      loadingActividades: false,
      tipoCambio: [],
      respuestaHacienda: [],
      comprobante: [],
      editedIndex: -1,
      modelFactura: {
        comprobante: [],
        comprobanteDetalle: [],
      },
      editedItem: {
        cia: "",
        codigoFact: "",
        tipoFact: "",
        fecha: new Date().toISOString().slice(0, 10),
        fechaString: "",
        tipoCambio: 1,
        clienteCod: "",
        clienteNombre: "",
        clienteCorreo: "",
        clienteCedula: "",
        clienteAreaTel: "",
        clienteTelefono: "",
        clienteNombreComercial: "",
        clienteProvincia: "",
        clienteCanton: "",
        clienteDistrito: "",
        clienteBarrio: "",
        clienteDireccion: "",
        clienteTipoId: "",
        mensajeHacienda: "",
        moneda: "",
        estadoHacienda: "",
        clavehacienda: "",
        subtotal: 0,
        totalDescuentos: 0,
        totalImpuesto: 0,
        totalComprobante: 0,
        codigoDev: "",
        estadoDev: 0,
        consHacienda: "",
        condicionVenta: "",
        medioPago: "",
        plazoCredito: 0,
        sucursal: "",
        terminal: "",
        xml: "",
        xmlFirmado: "",
        respuestaHacienda: "",
        fechaHacienda: Date,
        fechaHaciendaString: "",
        totalGravado: 0,
        totalExento: 0,
        consHacReal: "",
        cedulaReceptor: "",
        ordenCompra: "",
        observacion: "",
        usuario: "",
        enviado: false,
        reenviado: false,
        totalServGravados: 0,
        totalServExentos: 0,
        totalServExonerado: 0,
        totalMercanciasExentas: 0,
        totalMercanciasGravadas: 0,
        totalMercExonerada: 0,
        totalExonerado: 0,
        totalVenta: 0,
        totalVentaNeta: 0,
        totalIVADevuelto: 0,
        totalOtrosCargos: 0,
        totalIva1: 0,
        totalIva2: 0,
        totalIva4: 0,
        totalIva8: 0,
        totalIva13: 0,
        codigoActividad: "",
        emisorNombre: "",
        emisorNombreComercial: "",
        emisorTelefono: "",
        emisorCorreo: "",
        emisorDireccion: "",
        subTotal: 0,
        totalIVADevueltoStr: "",
        totalIva1Str: "",
        totalIva2Str: "",
        totalIva4Str: "",
        totalIva13Str: "",
        totalDescuentosStr: "",
        totalImpuestoStr: "",
        subtotalStr: "",
        totalComprobanteStr: "",
        nombreTabla: "",
        documentoOrigen: "",
        nombreTablaReferencia: "",
        estadoHaciendaEmisor: "",
        estadoInventario: "PENDIENTE",
      },
      defaultItem: {
        cia: "",
        codigoFact: "",
        tipoFact: "",
        fecha: Date,
        fechaString: "",
        tipoCambio: 1,
        clienteCod: "",
        clienteNombre: "",
        clienteCorreo: "",
        clienteCedula: "",
        clienteAreaTel: "",
        clienteTelefono: "",
        clienteNombreComercial: "",
        clienteProvincia: "",
        clienteCanton: "",
        clienteDistrito: "",
        clienteBarrio: "",
        clienteDireccion: "",
        clienteTipoId: "",
        mensajeHacienda: "",
        moneda: "",
        estadoHacienda: "",
        clavehacienda: "",
        subtotal: 0,
        totalDescuentos: 0,
        totalImpuesto: 0,
        totalComprobante: 0,
        codigoDev: "",
        estadoDev: 0,
        consHacienda: "",
        condicionVenta: "",
        medioPago: "",
        plazoCredito: 0,
        sucursal: "",
        terminal: "",
        xml: "",
        xmlFirmado: "",
        respuestaHacienda: "",
        fechaHacienda: Date,
        fechaHaciendaString: "",
        totalGravado: 0,
        totalExento: 0,
        consHacReal: "",
        cedulaReceptor: "",
        ordenCompra: "",
        observacion: "",
        usuario: "",
        enviado: false,
        reenviado: false,
        totalServGravados: 0,
        totalServExentos: 0,
        totalServExonerado: 0,
        totalMercanciasExentas: 0,
        totalMercanciasGravadas: 0,
        totalMercExonerada: 0,
        totalExonerado: 0,
        totalVenta: 0,
        totalVentaNeta: 0,
        totalIVADevuelto: 0,
        totalOtrosCargos: 0,
        totalIva1: 0,
        totalIva2: 0,
        totalIva4: 0,
        totalIva8: 0,
        totalIva13: 0,
        codigoActividad: "",
        emisorNombre: "",
        emisorNombreComercial: "",
        emisorTelefono: "",
        emisorCorreo: "",
        emisorDireccion: "",
        subTotal: 0,
        totalIVADevueltoStr: "",
        totalIva1Str: "",
        totalIva2Str: "",
        totalIva4Str: "",
        totalIva13Str: "",
        totalDescuentosStr: "",
        totalImpuestoStr: "",
        subtotalStr: "",
        totalComprobanteStr: "",
        nombreTabla: "",
        documentoOrigen: "",
        nombreTablaReferencia: "",
        estadoHaciendaEmisor: "",
        estadoInventario: "PENDIENTE",
      },
      ciaItem: {
        nombre: "",
        nombreComercial: "",
        cedula: "",
        provincia: "",
        canton: "",
        distrito: "",
        barrio: "",
        direccion: "",
        sucursal: "",
        terminal: "",
        moneda: "",
        moneda2: "",
        usuariohacienda: "",
        clavehacienda: "",
        propietarioCert: "",
        certificado: "",
        claveCert: "",
        esProd: false,
        correo: "",
        claveCcorreo: "",
        smtpCorreo: "",
        puertoCorreo: "",
        usaSeguridad: false,
        areaTel: "",
        telefono: "",
        tipoId: "",
        codigoActividad: "",
        image: "",
      },
      detalleEditedIndex: -1,
      detalleEditedItem: {
        cia: "",
        factura: "",
        tipoFact: "",
        numLinea: 0,
        cantidad: 0,
        articulo: "",
        descripcion: "",
        unidad: "",
        monto: 0,
        descuento: 0,
        totalLinea: 0,
        impuestosVentas: 0,
        sucursal: "",
        terminal: "",
        tipoCodigo: "",
        unidadMedidaComercial: "",
        impCodigo: "",
        impCodigoTarifa: "",
        impTarifa: "",
        cabys: "",
        porcDescuento: 0,
        tipoCambio: 0,
        tipoProducto: "",
        montoTotal: 0,
        subTotal: 0,
        impuestoNeto: 0,
        moneda: "",
        montoStr: "",
        totalLineaStr: "",
      },
      detalleDefaultItem: {
        cia: "",
        factura: "",
        tipoFact: "",
        numLinea: 0,
        cantidad: 0,
        articulo: "",
        descripcion: "",
        unidad: "",
        monto: 0,
        descuento: 0,
        totalLinea: 0,
        impuestosVentas: 0,
        sucursal: "",
        terminal: "",
        tipoCodigo: "",
        unidadMedidaComercial: "",
        impCodigo: "",
        impCodigoTarifa: "",
        impTarifa: "",
        cabys: "",
        porcDescuento: 0,
        tipoCambio: 0,
        tipoProducto: "",
        montoTotal: 0,
        subTotal: 0,
        impuestoNeto: 0,
        moneda: "",
        montoStr: "",
        totalLineaStr: "",
      },
      showNewData: false,
      showNewDataArti: false,
      nameRules: [(v) => !!v || "Campo requerido"],
      tempFile: "",
      modelFile: null,
    };
  },

  computed: {
    ...mapGetters(["user", "strCia"]),
    formTitle() {
      return this.editedIndex === -1 ? "Agregar Articulo" : "Editar Articulo";
    },
    itemsFilter() {
      return this.items.map((x) => ({
        ...x,
        isSelectable: x.codigoDev == "PENDIENTE",
      }));
    },
  },

  watch: {
    dialog(val) { val || this.close(); },
    dialogArticulos(val) { val || this.close(); },
    search() { this.snackValue = false; },
    strCia: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
          this.getActividades();
          this.getCondicionVenta();
        }
      },
    },
  },

  created() {
    this.getMedioPago();
  },

  methods: {
    signalChange: function (evt) {
      this.snackText = "Si llega al escribir" + evt;
      this.snackValue = true;
    },

    enviarSeleccionados() {
      this.visibleLoteProgress = true;
      let me = this;

      if (this.codigoActividadAll != "" && this.estadoDevAll != 0) {
        if (this.selected.length > 0) {
          for (const item of this.selected) {
            item.fechaHacienda = new Date();
            item.cia = this.strCia;
            item.usuario = this.user.id;
            item.tipoFact = "05";
            item.nombreTabla = "Compras";
            item.codigoActividad = this.codigoActividadAll;
            item.estadoDev = this.estadoDevAll;
          }

          this.snackText = "Procesando por favor espere";
          this.snackValue = true;

          axios
            .post("api/Compras/enviarLoteCompras", this.selected)
            .then(function (response) {
              me.visibleLoteProgress = false;
              me.respuestaHacienda = response.data;
              me.getData();
              me.snackValue = false;
            })
            .catch(function (error) {
              console.log(error);
            });

          me.cancelarValid = false;
          me.guardarValid = false;
          me.incluirValid = true;
        } else {
          this.snackText = "Debe seleccionar al menos un registro";
          this.snackValue = true;
        }
      } else {
        this.snackText = "Por favor valide los datos de Actividad Comercial y Estado Respuesta";
        this.snackValue = true;
      }
    },

    getTipoDocumento(clave) {
      let tipoDocumento = "";
      if (clave.substring(29, 31) === "01") tipoDocumento = "Factura";
      if (clave.substring(29, 31) === "02") tipoDocumento = "Nota Débito";
      if (clave.substring(29, 31) === "03") tipoDocumento = "Nota Crédito";
      if (clave.substring(29, 31) === "04") tipoDocumento = "Tiquete";
      return tipoDocumento;
    },

    getData() {
      let me = this;
      axios
        .get("api/Compras/GetCompras?cia=" + this.strCia + "&docNombre=Compras&tipoDoc=05", { crossdomain: true })
        .then(function (response) { me.items = response.data; })
        .catch(function (error) { console.log(error); });
    },

    openDocViewer(url, title) {
      this.docViewerUrl = url;
      this.docViewerTitle = title;
      this.docViewerDialog = true;
    },

    abrirEnNuevaPestana() { window.open(this.docViewerUrl, '_blank'); },

    getXMLRecibido() {
      const base = axios.defaults.baseURL;
      this.openDocViewer(`${base}/api/Compras/getFileContent?cia=${this.editedItem.cia}&clave=${this.editedItem.clavehacienda}&consHacReal=${this.editedItem.consHacReal}&type=received`, "XML Recibido — " + this.editedItem.clavehacienda);
    },

    getXMLFirmado() {
      const base = axios.defaults.baseURL;
      this.openDocViewer(`${base}/api/Compras/getFileContent?cia=${this.editedItem.cia}&clave=${this.editedItem.clavehacienda}&consHacReal=${this.editedItem.consHacReal}&type=signed`, "XML Enviado — " + this.editedItem.consHacReal);
    },

    getXMLRespuesta() {
      const base = axios.defaults.baseURL;
      this.openDocViewer(`${base}/api/Compras/getFileContent?cia=${this.editedItem.cia}&clave=${this.editedItem.clavehacienda}&consHacReal=${this.editedItem.consHacReal}&type=response`, "Respuesta XML — " + this.editedItem.consHacReal);
    },

    getActividades() {
      if (!this.strCia) return;
      this.loadingActividades = true;
      axios.get("api/General/getActividadesByCia?cia=" + this.strCia)
        .then(res => { this.actividades = res.data; })
        .catch(error => { console.error("Error cargando actividades:", error); })
        .finally(() => { this.loadingActividades = false; });
    },

    async openInventoryMapper(item) {
      this.inventoryLines = []; 
      this.currentProveedorXml = null;
      this.currentLocalProveedor = null;
      this.editedItem = Object.assign({}, item);

      try {
        const res = await axios.get(`api/Compras/getModeloComprobante?cia=${this.strCia}&clave=${item.clavehacienda}&docNombre=Compras`);
        const comprobante = res.data.comprobante;
        this.inventoryLines = res.data.comprobanteDetalle;

        this.currentProveedorXml = {
          Nombre: comprobante.clienteNombre || comprobante.emisorNombre,
          NombreComercial: comprobante.clienteNombreComercial || comprobante.emisorNombreComercial || comprobante.clienteNombre,
          Identificacion: { Numero: item.cedulaReceptor || comprobante.cedulaReceptor, Tipo: comprobante.clienteTipoId || "01" },
          CorreoElectronico: comprobante.clientecorreo || comprobante.emisorCorreo,
          Telefono: { Numero: comprobante.clienteTelefono || "", Area: comprobante.clienteAreaTel || "506" },
          Ubicacion: { Provincia: comprobante.clienteProvincia || "1", Canton: comprobante.clienteCanton || "01", Distrito: comprobante.clienteDistrito || "01", Barrio: comprobante.clienteBarrio || "01", OtrasSenas: comprobante.clienteDireccion || "" }
        };

        const resProv = await axios.get(`api/Proveedores/getProveedor?cia=${this.strCia}&codigo=&cedula=${this.currentProveedorXml.Identificacion.Numero}`);
        this.currentLocalProveedor = resProv.data;
        this.showInventoryMapper = true;
      } catch (err) {
        console.error(err);
        this.snackText = "Error al inicializar el mapeo de inventario";
        this.snackValue = true;
      }
    },

    onSupplierRegistered(cedula) {
      this.snackText = "Proveedor registrado exitosamente";
      this.snackValue = true;
      axios.get(`api/Proveedores/getProveedor?cia=${this.strCia}&codigo=&cedula=${cedula}`)
        .then(res => { this.currentLocalProveedor = res.data; });
    },

    async processInventoryConfirm(payload) {
       const { mappings, updateCatalog, proveedorCodigo } = payload;
       if (!confirm("¿Confirma el ingreso de estos artículos al inventario?")) return;
       this.processingInventory = true;
       try {
          const modelo = {
             Movimiento: {
                tipo: 1,
                fecha: new Date().toISOString(),
                descripcion: "Ingreso de Mercadería - Compra # " + (this.editedItem.codigoFact || this.editedItem.clavehacienda),
                referencia: "COMPRA: " + this.editedItem.clavehacienda + " | TIPO: " + (this.editedItem.nombreTabla || "Compras"),
                cia: this.strCia,
                usuario: this.user.id,
                estado: "A",
                proveedorCodigo: proveedorCodigo || this.editedItem.cedulaEmisor
             },
             Detalles: mappings.map(m => ({
                articulo: m.articuloCodigo,
                cabys: m.articuloCabys || "",
                numLinea: m.lineaXML,
                cantidad: m.cantidadInventario,
                descripcion: m.articuloNombre,
                costo: m.costoUnitario,
                precio: m.precioSinIva,
                codigoInternoProveedor: m.codigoInternoProveedor
             }))
          };
          await axios.post("api/Articulos/insertArticulosMovimientos", modelo);
          if (updateCatalog && proveedorCodigo) {
             const catalogItems = mappings.map(m => ({
                Cia: this.strCia,
                CodigoArticulo: m.articuloCodigo,
                ProveedorCodigo: proveedorCodigo,
                UltimoCosto: m.costoUnitario,
                CodigoInternoProveedor: m.codigoInternoProveedor
             }));
             await axios.post("api/Articulos/bulkSaveProveedorArticulo", catalogItems);
          }
          this.snackText = "Inventario y Catálogo actualizados exitosamente";
          this.snackValue = true;
          this.showInventoryMapper = false;
          this.getData();
       } catch (err) {
          console.error(err);
          this.snackText = "Error en el proceso: " + (err.response && err.response.data ? err.response.data : err.message);
          this.snackValue = true;
       } finally { this.processingInventory = false; }
    },

    getCondicionVenta() {
      let me = this;
      axios.get("api/General/getCondicionVenta")
        .then(function (response) { me.condicionesVenta = response.data; })
        .catch(function (error) { console.log(error); });
    },

    getMedioPago() {
      let me = this;
      axios.get("api/General/getMediosPago")
        .then(function (response) { me.mediosPago = response.data; })
        .catch(function (error) { console.log(error); });
    },

    getCondicionVentaText(codigo) {
      if (!codigo) return "";
      const cleanCodigo = codigo.toString().trim();
      const item = this.condicionesVenta.find((x) => Number(x.codigo) == Number(cleanCodigo));
      return item ? item.descripcion : cleanCodigo;
    },

    getSucursales() {
      let me = this;
      axios.get("api/Cias/getSucursalesByCia?cia=" + this.strCia)
        .then(function (response) { me.sucursales = response.data; })
        .catch(function (error) { console.log(error); });
    },

    getTerminales(sucursal) {
      let me = this;
      axios.get("api/Cias/getTerminales?cia=" + this.strCia + "&sucursal=" + sucursal)
        .then(function (response) {
          me.terminales = response.data;
          me.editedItem.terminal = me.terminales[0]["terminalId"];
        })
        .catch(function (error) { console.log(error); });
    },

    editItem(item) {
      if (this.actividades.length === 0) this.getActividades();
      let me = this;
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$set(this.editedItem, 'estadoInventario', item.estadoInventario || 'PENDIENTE');
      this.editedItem.clasificacion = item.clasificacion || "";
      this.lineasDetalle = [];
      this.drawerForm = true;
      this.activePanels = [0, 1, 2];

      if (this.editedItem.estadoHacienda === "ACEPTADO") {
        this.consultarEstadoValid = false;
        this.guardarValid = false;
        this.cancelarValid = true;
        this.verXMLFirmado = true;
        this.verXMLRespuesta = true;
      } else {
        this.consultarEstadoValid = true;
        this.guardarValid = true;
        this.cancelarValid = true;
        this.verXMLFirmado = false;
        this.verXMLRespuesta = false;
        if (this.editedItem.estadoDev === 0) this.editedItem.estadoDev = 1;
      }

      this.editedItem.nombreTabla = "Compras";
      axios.get("api/Compras/getModeloComprobante?cia=" + this.strCia + "&clave=" + this.editedItem.clavehacienda + "&docNombre=Compras", { crossdomain: true })
        .then(function (response) {
          me.modelFactura = response.data;
          me.lineasDetalle = me.modelFactura.comprobanteDetalle;
          if (me.modelFactura.comprobante) {
            me.editedItem.totalIVADevueltoStr = me.modelFactura.comprobante.totalIVADevueltoStr;
            me.editedItem.totalIva1Str = me.modelFactura.comprobante.totalIva1Str;
            me.editedItem.totalIva2Str = me.modelFactura.comprobante.totalIva2Str;
            me.editedItem.totalIva4Str = me.modelFactura.comprobante.totalIva4Str;
            me.editedItem.totalIva13Str = me.modelFactura.comprobante.totalIva13Str;
            me.editedItem.totalDescuentosStr = me.modelFactura.comprobante.totalDescuentosStr;
            me.editedItem.totalImpuestoStr = me.modelFactura.comprobante.totalImpuestoStr;
            me.editedItem.subtotalStr = me.modelFactura.comprobante.subtotalStr;
            me.editedItem.totalComprobanteStr = me.modelFactura.comprobante.totalComprobanteStr;
            me.editedItem.estadoHaciendaEmisor = me.modelFactura.comprobante.estadoHaciendaEmisor;
            me.editedItem.fechaHaciendaString = me.modelFactura.comprobante.fechaHaciendaString;
            me.editedItem.condicionVenta = me.modelFactura.comprobante.condicionVenta;
            me.editedItem.medioPago = me.modelFactura.comprobante.medioPago;
            me.editedItem.plazoCredito = me.modelFactura.comprobante.plazoCredito;
            if (me.editedItem.estadoHacienda !== "ACEPTADO") me.editedItem.codigoActividad = me.modelFactura.comprobante.codigoActividad;
            me.editedItem.clasificacion = me.modelFactura.comprobante.clasificacion;
            me.$set(me.editedItem, 'estadoInventario', me.modelFactura.comprobante.estadoInventario || me.editedItem.estadoInventario);
          }
        })
        .catch(function (error) { console.log(error); });
    },

    cerrar() {
      this.drawerForm = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.lineasDetalle = [];
        this.activePanels = [0, 1, 2];
        this.valid = false;
        this.cancelarValid = false;
        this.verXMLFirmado = false;
        this.verXMLRespuesta = false;
        this.consultarEstadoValid = false;
      });
    },

    getEstadoColor(estado) {
      if (!estado) return 'grey lighten-1';
      const e = estado.toUpperCase();
      if (e.includes('ACEPTADO')) return 'teal darken-2';
      if (e.includes('RECHAZADO')) return 'red accent-2';
      if (e.includes('PROCESANDO')) return 'blue lighten-1';
      return 'grey lighten-1';
    },

    updateManualClassification(val) {
      const clave = this.editedItem.clavehacienda;
      if (!clave) return;
      axios.get(`api/Compras/updateClasificacion?clave=${clave}&cia=${this.strCia}&docNombre=Compras&estado=${val || ''}`)
        .then(() => {
          this.snackText = "Clasificación actualizada exitosamente ✨";
          this.snackValue = true;
          const index = this.items.findIndex(i => i.clavehacienda === clave);
          if (index !== -1) this.items[index].clasificacion = val;
        })
        .catch(err => {
          console.error(err);
          this.snackText = "Error al actualizar clasificación";
          this.snackValue = true;
        });
    },

    consultarEstadoHacienda() {
      let me = this;
      this.comprobante = this.editedItem;
      axios.post("api/Compras/obtenerRespuestaHacienda", this.comprobante)
        .then(function (response) {
          me.respuestaHacienda = response.data;
          me.editedItem.estadoHacienda = me.respuestaHacienda.eInvoiceStatus;
          me.editedItem.mensajeHacienda = me.respuestaHacienda.details;
          if (me.editedItem.estadoHacienda !== "PROCESANDO") me.consultarEstadoValid = false;
          if (me.editedItem.estadoHacienda === "ACEPTADO" || me.editedItem.estadoHacienda === "RECHAZADO") {
            me.imprimirValid = true;
            me.reenviarValid = true;
            me.verPDF = true;
            me.verXMLFirmado = true;
            me.verXMLRespuesta = true;
          } else {
            me.imprimirValid = false;
            me.reenviarValid = false;
            me.verPDF = false;
            me.verXMLFirmado = false;
            me.verXMLRespuesta = false;
          }
          me.getData();
        })
        .catch(function (error) { console.log(error); });
    },

    save() {
      let me = this;
      if (this.editedItem.codigoActividad != "" && this.editedItem.estadoDev != 0) {
        this.visibleProgress = true;
        this.editedItem.fechaHacienda = new Date();
        this.editedItem.cia = this.strCia;
        this.editedItem.usuario = this.user.id;
        this.editedItem.tipoFact = "05";
        this.editedItem.nombreTabla = "Compras";
        axios.post("api/Compras/enviarCompra", this.editedItem)
          .then(function (response) {
            me.visibleProgress = false;
            me.respuestaHacienda = response.data;
            me.editedItem.clavehacienda = me.respuestaHacienda.claveHacienda;
            me.editedItem.consHacReal = me.respuestaHacienda.consecutivoHacienda;
            me.editedItem.estadoHacienda = me.respuestaHacienda.eInvoiceStatus;
            me.editedItem.mensajeHacienda = me.respuestaHacienda.details;
            if (me.editedItem.estadoHacienda === "ACEPTADO" || me.editedItem.estadoHacienda === "RECHAZADO") {
              me.imprimirValid = true;
              me.reenviarValid = true;
              me.verPDF = true;
              me.verXMLFirmado = true;
              me.verXMLRespuesta = true;
            } else {
              me.imprimirValid = false;
              me.reenviarValid = false;
              me.verPDF = false;
              me.verXMLFirmado = false;
              me.verXMLRespuesta = false;
            }
            if (me.editedItem.estadoHacienda === "PROCESANDO") me.consultarEstadoValid = true;
            me.getData();
          })
          .catch(function (error) { console.log(error); });
        me.cancelarValid = false;
        me.guardarValid = false;
        me.incluirValid = true;
        me.snackValue = false;
      } else {
        this.snackText = "Por favor valide los datos de Actividad Comercial y Estado Respuesta";
        this.snackValue = true;
      }
    },

    close() {
      this.dialogArticulos = false;
      this.$nextTick(() => {
        this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
        this.detalleEditedIndex = -1;
      });
    },
  },
};
</script>

<style scoped>
/* === AC DESIGN SYSTEM (Aceptación de Compras) === */
.ac-container {
  background-color: #f1f5f9;
  min-height: 100vh;
}
.ac-toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}
.ac-toolbar-title {
  font-size: 0.95rem !important;
  letter-spacing: 1.5px;
}
.ac-btn {
  border-radius: 4px !important;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-size: 0.75rem !important;
}
.ac-table-card {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}

/* Tabla principal */
.ac-table { background-color: transparent !important; }
.ac-table >>> thead th {
  background-color: #37474f !important;
  color: #ffffff !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.07em;
  border-bottom: none !important;
}
.ac-table >>> tbody tr { cursor: pointer; }
.ac-table >>> td {
  font-size: 0.85rem !important;
}
.ac-table >>> tbody tr:hover {
  background-color: rgba(55, 71, 79, 0.05) !important;
}
.theme--dark .ac-table >>> tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* Inputs de filtro */
.ac-search >>> .v-input__slot {
  border-radius: 4px !important;
}

/* Tabla de detalle */
.modern-table { background-color: transparent !important; }
.modern-table >>> thead th {
  background-color: #37474f !important;
  color: #ffffff !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.07em;
  border-bottom: none !important;
}
.modern-table >>> td {
  font-size: 0.85rem !important;
}
.theme--dark .modern-table >>> thead th {
  background-color: #263238 !important;
  color: #cfd8dc !important;
}

/* Drawer */
.ac-drawer >>> .v-navigation-drawer__content {
  background-color: #ffffff !important;
}
.theme--dark .ac-drawer >>> .v-navigation-drawer__content {
  background-color: #0f172a !important;
}
.ac-drawer-header {
  background-color: #37474f;
  flex-shrink: 0;
}
.ac-drawer-header--dark {
  background-color: #263238 !important;
}
.ac-drawer-footer {
  background-color: #f8fafc;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}
.ac-drawer-footer--dark {
  background-color: #1e293b !important;
  border-top: 1px solid rgba(255, 255, 255, 0.07) !important;
}

/* Expansion panels */
.modern-panels >>> .v-expansion-panel { border: 1px solid rgba(0,0,0,0.07) !important; border-radius: 4px !important; }
.theme--dark .modern-panels >>> .v-expansion-panel { border: 1px solid rgba(255,255,255,0.07) !important; }
.modern-panels >>> .v-expansion-panel--active {
  border: 1px solid rgba(55, 71, 79, 0.3) !important;
  box-shadow: 0 4px 12px rgba(55, 71, 79, 0.07) !important;
  margin-bottom: 2px !important;
  border-radius: 4px !important;
}
.modern-panels >>> .v-expansion-panel + .v-expansion-panel { margin-top: 2px !important; }
.modern-panels >>> .v-expansion-panel-header {
  min-height: 40px !important;
  padding: 0 12px !important;
  font-size: 0.875rem !important;
  border-radius: 4px !important;
}
.modern-panels >>> .v-expansion-panel-content__wrap { padding: 4px 4px 6px !important; }

.border-primary-light {
  border: 1px solid rgba(55, 71, 79, 0.2) !important;
}

/* Visor de documentos */
.doc-viewer-toolbar {
  background-color: #37474f;
  min-height: 44px;
}

.right-input >>> input {
  text-align: right;
}
</style>